import { useLiquidityEventContract } from "pages/Event/hooks/blockchain/contracts/useLiquidityEventContract";
import { BigNumber } from "@ethersproject/bignumber";
import React from "react";
import { BASIS_POINTS_DIVISOR, DEFAULT_SLIPPAGE_AMOUNT } from "../../../../lib/legacy";
import { useLocalStorageSerializeKey } from "../../../../lib/localStorage";
import { useChainId } from "../../../../lib/chains";
import { SLIPPAGE_BPS_KEY } from "../../../../config/localStorage";
import { t } from "@lingui/macro";
import { callContract } from "../../../../lib/contracts";
import { usePendingTxns } from "../../../../domain/transactions/usePendingTxns";
import { formatAmount } from "../../../../lib/numbers";

export const useEventPurchasePlp = () => {
  const eventContract = useLiquidityEventContract();
  const [isMutating, setIsMutating] = React.useState(false);
  const { chainId } = useChainId();
  const [, setPendingTxns] = usePendingTxns();
  const [savedSlippageAmount = DEFAULT_SLIPPAGE_AMOUNT] = useLocalStorageSerializeKey(
    [chainId, SLIPPAGE_BPS_KEY],
    DEFAULT_SLIPPAGE_AMOUNT
  );

  const purchasePlp = async (_amountIn: BigNumber, _minUsdg: BigNumber, _minPlp: BigNumber, successCb?: () => void) => {
    setIsMutating(true);
    const minPlp = _minPlp.mul(BASIS_POINTS_DIVISOR - savedSlippageAmount).div(BASIS_POINTS_DIVISOR);
    return await callContract(chainId, eventContract, "purchasePlp", [_amountIn, 0, minPlp], {
      value: 0,
      sentMsg: t`Buy submitted.`,
      failMsg: t`Buy failed.`,
      successMsg: t`${formatAmount(minPlp, 18, 4, true)} PLP bought with ${formatAmount(_amountIn, 18, 2, true)} USDT!`,
      setPendingTxns,
      txnSuccessCallback: () => {
        setIsMutating(false);
        successCb && successCb();
      },
    }).catch(() => {
      setIsMutating(false);
    });
  };

  return {
    isMutating,
    purchasePlp,
  };
};
